// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AcceptanceController from "./acceptance_controller"
application.register("acceptance", AcceptanceController)

import AcknowledgeNoticeController from "./acknowledge_notice_controller"
application.register("acknowledge-notice", AcknowledgeNoticeController)

import ActivityIndicatorController from "./activity_indicator_controller"
application.register("activity-indicator", ActivityIndicatorController)

import Admin__ExplodedView__ItemManagerController from "./admin/exploded_view/item_manager_controller"
application.register("admin--exploded-view--item-manager", Admin__ExplodedView__ItemManagerController)

import Admin__ExplodedView__ItemPickerController from "./admin/exploded_view/item_picker_controller"
application.register("admin--exploded-view--item-picker", Admin__ExplodedView__ItemPickerController)

import Admin__ExplodedView__ItemSearchController from "./admin/exploded_view/item_search_controller"
application.register("admin--exploded-view--item-search", Admin__ExplodedView__ItemSearchController)

import Admin__FetchController from "./admin/fetch_controller"
application.register("admin--fetch", Admin__FetchController)

import Admin__OpenOnLoadController from "./admin/open_on_load_controller"
application.register("admin--open-on-load", Admin__OpenOnLoadController)

import Admin__TabOpenerController from "./admin/tab_opener_controller"
application.register("admin--tab-opener", Admin__TabOpenerController)

import Admin__TriggerOnClickController from "./admin/trigger_on_click_controller"
application.register("admin--trigger-on-click", Admin__TriggerOnClickController)

import AssemblyHighlightController from "./assembly_highlight_controller"
application.register("assembly-highlight", AssemblyHighlightController)

import AssemblySchematicsController from "./assembly_schematics_controller"
application.register("assembly-schematics", AssemblySchematicsController)

import AssemblyShowAllController from "./assembly_show_all_controller"
application.register("assembly-show-all", AssemblyShowAllController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AutosaveFormController from "./autosave_form_controller"
application.register("autosave-form", AutosaveFormController)

import AutosubmitFormController from "./autosubmit_form_controller"
application.register("autosubmit-form", AutosubmitFormController)

import DisableController from "./disable_controller"
application.register("disable", DisableController)

import EnforceSelectionController from "./enforce_selection_controller"
application.register("enforce-selection", EnforceSelectionController)

import FetcherController from "./fetcher_controller"
application.register("fetcher", FetcherController)

import FocusController from "./focus_controller"
application.register("focus", FocusController)

import InputObserverController from "./input_observer_controller"
application.register("input-observer", InputObserverController)

import KitLinesExpansionController from "./kit_lines_expansion_controller"
application.register("kit-lines-expansion", KitLinesExpansionController)

import LineItemController from "./line_item_controller"
application.register("line-item", LineItemController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import ProductSuggestionController from "./product_suggestion_controller"
application.register("product-suggestion", ProductSuggestionController)

import QuantityController from "./quantity_controller"
application.register("quantity", QuantityController)

import QuantityStepController from "./quantity_step_controller"
application.register("quantity-step", QuantityStepController)

import SearchTableController from "./search_table_controller"
application.register("search-table", SearchTableController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import TabController from "./tab_controller"
application.register("tab", TabController)

import TillController from "./till_controller"
application.register("till", TillController)

import ValueFetcherController from "./value_fetcher_controller"
application.register("value-fetcher", ValueFetcherController)
